import { autoPlannerURLs } from '../features/autoplanner/utils/autoPlannerURLs';
import { yaantracURLs } from '../features/yaantrac/utils/yaantracURLs';
import { logisticsURLs } from '../features/truckmanagement/utils/logisticsURLs';
import { deliveryTrackingURLs } from '../features/deliverytracking/utils/deliveryTrackingURLs';
import { commonURLS } from '../common/utils/commonURLs';

const URLs = {
  ...commonURLS,

  ...yaantracURLs,

  ...autoPlannerURLs,

  ...logisticsURLs,

  ...deliveryTrackingURLs
};

export default URLs;
